export default __webpack_public_path__ + "static/media/blog1_4.0e4e63eb.png";